import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";
import { toast } from "sonner";
import usePolling from "@/hooks/usePolling";

const fmt = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

export default function IncomingOrders() {
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  const load = () => api.get("/vendor/orders").then((r) => setOrders(r.data));
  // New POs and status changes from the contractor side show up on their
  // own — no manual refresh needed.
  usePolling(load, 20000);

  const confirm = async (id, e) => {
    e.stopPropagation();
    await api.post(`/vendor/orders/${id}/confirm`);
    toast.success("Order confirmed");
    load();
  };

  return (
    <div className="p-6 md:p-8" data-testid="incoming-orders-page">
      <h1 className="text-2xl font-extrabold tracking-tight">Incoming Orders</h1>
      <p className="text-slate-500 text-sm mt-1">Confirm and fulfill purchase orders from contractors.</p>

      <div className="overflow-x-auto">
        <table className="w-full mt-7 text-[13px]" data-testid="orders-table">
          <thead>
            <tr className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold border-b border-slate-100">
              <th className="text-left py-2.5">PO #</th><th className="text-left py-2.5">Job</th><th className="text-left py-2.5">Requested By</th><th className="text-right py-2.5">Amount</th><th className="text-left py-2.5 pl-3">Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {orders.map((po) => (
              <tr key={po.id} onClick={() => navigate(`/vendor/orders/${po.id}`)} className="cursor-pointer hover:bg-slate-50 border-b border-slate-50" data-testid={`order-row-${po.po_number}`}>
                <td className="py-3 mono text-sky-600 font-medium">{po.po_number}</td>
                <td className="py-3 text-slate-600">{po.job_name || "—"}</td>
                <td className="py-3 text-slate-600">{po.requester_name || "—"}</td>
                <td className="py-3 text-right mono font-medium">{fmt(po.amount)}</td>
                <td className="py-3 pl-3"><StatusBadge status={po.status} /></td>
                <td className="py-3 text-right">
                  {po.status === "sent" && <button onClick={(e) => confirm(po.id, e)} data-testid={`confirm-order-${po.id}`} className="px-3 py-1.5 rounded-lg bg-sky-500 text-white text-[12px] font-semibold">Confirm</button>}
                </td>
              </tr>
            ))}
            {orders.length === 0 && <tr><td colSpan={6} className="py-10 text-center text-slate-400 text-sm">No orders yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
